import {BrowserXhr} from '@angular/http';
import {Injectable} from '@angular/core';

@Injectable()
export class ProgressBrowserXhr extends BrowserXhr {

    constructor(private _progressService: ProgressService) {
        super();
    }

    build(): any {
        const xhr = super.build();
        const progressCallback = this._progressService.use();
        if (progressCallback) {
            xhr.upload.addEventListener('progress', (event: ProgressEvent) => {
                const progressPercent = Math.round(100 * event.loaded / event.total);
                progressCallback.call(window, progressPercent);
            });
        }
        return xhr;
    }

}

type ProgressCallback = (progress: number) => void;

@Injectable()
export class ProgressService {

    private _callback: ProgressCallback;

    register(callback: ProgressCallback): void {
        this._callback = callback;
    }

    use(): ProgressCallback {
        const callback = this._callback;
        this._callback = null;
        return callback;
    }

}